import { Candidate, CandidatePriority } from '../../candidate';
import { JobTitle } from '../job-title-type';
import { JobTitleEnum } from '../job-titles.enum';

export type SpecificPriorityFn<C = Candidate> = (jobTitleSpecification: JobTitleSpecification, candidate: C) => CandidatePriority;
export type DowngradeFn<T = unknown, P = undefined> = (
  selectedJobTitles: JobTitleSpecification,
  answer: T,
  props: P,
) => JobTitleEnum[] | null;

export enum JobTitleCategory {
  Standard = 'standard',
  Companion = 'companion',
  Praxia = 'praxia',
  Therapist = 'therapist',
}

export type JobTitleSpecification = {
  jobTitle: RequiredJobTitle;
  category: JobTitleCategory;
  similarJobTitles: RequiredJobTitle[];
  frequency: number;
};

export type RequiredJobTitle = Required<Pick<JobTitle, 'id' | 'deputy' | 'title' | 'trackingPriority' | 'area' | 'typeOfEmployer'>>;
